import { useEffect, useState } from "react";
import Icon from "../panel/Icon";
import Carousel from "./Carousel";
import { uiTexts } from "../../i18n.js";
import { livePromos, PROMO_SECONDS } from "../../promos.js";
import { PROMOS_PRO_ONLY } from "../../plans.js";

// Promos que se ven ahora; se revisa cada minuto por si alguna empieza o termina.
export const useLivePromos = (business) => {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 60 * 1000);
        return () => clearInterval(id);
    }, []);
    return livePromos(business, PROMOS_PRO_ONLY, now);
}

// Una promo: con foto (texto blanco sobre la foto) o con el color de los botones del menú.
// Si tiene un producto asociado, al tocarla se abre ese producto.
const PromoSlide = ({ promo, product, onOpen, lang, tr, preview }) => {
    const t = uiTexts(lang);
    const content = (
        <>
            {promo.imagen && <img className="lp-menu-promo-img" src={promo.imagen} alt="" draggable="false"/>}
            <span className="lp-menu-promo-text">
                <strong>{tr(promo.titulo)}</strong>
                {promo.texto && <span>{tr(promo.texto)}</span>}
                {product && <span className="lp-menu-promo-link">{t.seeProduct} <Icon name="arrow" size={15} strokeWidth={2.4}></Icon></span>}
            </span>
        </>
    );
    const className = "lp-menu-promo" + (promo.imagen ? " lp-menu-promo-photo" : "");
    if (product && onOpen) {
        return <button type="button" className={className} tabIndex={preview ? -1 : undefined} onClick={() => !preview && onOpen(product)}>{content}</button>;
    }
    return <div className={className}>{content}</div>;
}

// Banner arriba del menú. `promos` son las que se ven (useLivePromos); `products` sirve
// para encontrar el producto de cada promo (si ya no está, la promo se ve sin link).
const PromoBanner = ({ promos, products = [], onOpen, lang = "es", tr = (text) => text, preview }) => {
    if (!promos.length) return null;
    const t = uiTexts(lang);
    const productOf = (promo) => promo.producto ? products.find((p) => p.id === promo.producto) : null;
    const slides = promos.map((promo) => <PromoSlide key={promo.id} promo={promo} product={productOf(promo)} onOpen={onOpen} lang={lang} tr={tr} preview={preview}></PromoSlide>);

  return (
    <section className="lp-menu-promos" aria-label={t.promos}>
        {slides.length === 1 ? slides[0] :
            <Carousel count={slides.length} label={t.promos} auto={preview ? 0 : PROMO_SECONDS * 1000} className="lp-menu-promos-carousel" lang={lang}>
                {slides}
            </Carousel>
        }
    </section>
  )
}

export default PromoBanner
